import { render, staticRenderFns } from "./CreateOrderShipmentPopUp.vue?vue&type=template&id=6ad768e0&scoped=true&"
import script from "./CreateOrderShipmentPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateOrderShipmentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderShipmentPopUp.vue?vue&type=style&index=0&id=6ad768e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad768e0",
  null
  
)

export default component.exports